// extracted by mini-css-extract-plugin
export default {"localeForm":"localeForm---WUK7l"};